import React, { useState, useCallback } from 'react';
import styled from 'styled-components';
import { useMutation, useQueryClient } from 'react-query';

import { getRandomColor } from 'src/UIComponents/utils/colors';
import { Button, Input } from 'src/UIComponents';
import { createTag } from 'src/api-services';

const InputContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

function TagAdd({ ...rest }) {
  const [title, setTitle] = useState('');
  const queryClient = useQueryClient();

  const { mutate, isLoading } = useMutation(createTag, {
    onSuccess: ({ data: createdItem }) => {
      queryClient.setQueryData('tags', (cachedQuery) => {
        return {
          ...cachedQuery,
          data: [createdItem, ...cachedQuery.data],
        };
      });
      setTitle('');
    },
  });
  const doSave = useCallback(() => {
    if (isLoading || title.trim() === '') {
      return;
    }
    mutate({
      title: title.trim(),
      color: getRandomColor(),
    });
  }, [mutate, isLoading, title]);

  const handleOnChange = useCallback(
    (event) => {
      setTitle(event.target.value);
    },
    [setTitle]
  );
  const handleKeyPress = useCallback(
    (event) => {
      const char = event.which || event.charCode;
      if (char === 13) {
        doSave();
      }
    },
    [doSave]
  );

  return (
    <div {...rest}>
      <InputContainer>
        <Input
          value={title}
          onChange={handleOnChange}
          onKeyPress={handleKeyPress}
        />
        <Button $color="primary" onClick={doSave} disabled={isLoading}>
          Add
        </Button>
      </InputContainer>
    </div>
  );
}

export default TagAdd;
